import { UI_PRIMITIVE__slider } from '@/components/ui/slider/UI_PRIMITIVE__slider';
import { CONSTANTS__client } from '@/constants/CONSTANTS__client';
import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_effect } from '@/hooks/_base/use_effect';
import { use_slice_ui } from '@/hooks/store/use_slices';
import { PLACEHOLDER_bar_line } from '@/pages/_base/views/PLACEHOLDER_bar_line';
import { ENUM__image_brush } from '@/pages/page_generation/layouts/assets_images/_base/ENUM__image_brush';
import { LOCAL__ui_set_number } from '@/state/ui/_base/LOCAL__ui_set_number';
import { useState } from 'react';

const { IMAGE_BRUSH_SIZE_RANGE } = CONSTANTS__client;

export function G_SLIDER__image_brush_size() {
  /*
   * STORE
   */
  const dispatch = use_dispatch();

  const { g_general__ui_disabled, g_image_edit__brush_size, g_image_edit__brush } = use_slice_ui([
    'g_general__ui_disabled',
    'g_image_edit__brush_size',
    'g_image_edit__brush',
  ]);

  /*
   * STATE
   */
  const [value, set_value] = useState(g_image_edit__brush_size);

  /*
   * EFFECTS
   */

  use_effect(() => {
    set_value(g_image_edit__brush_size);
  }, [g_image_edit__brush_size]);

  /*
   * EVENTS
   */
  function onValueChange(values: number[]) {
    set_value(values[0]);
  }

  async function onValueCommit(values: number[]) {
    set_value(values[0]);

    dispatch(LOCAL__ui_set_number({ key: 'g_image_edit__brush_size', value: values[0] }));
  }
  /*
   * METHODS
   */

  function is_disabled() {
    return g_general__ui_disabled;
  }

  function render_slider() {
    if (g_image_edit__brush == ENUM__image_brush.POINTER) return <PLACEHOLDER_bar_line />;

    return (
      <UI_PRIMITIVE__slider
        disabled={is_disabled()}
        min={IMAGE_BRUSH_SIZE_RANGE.min}
        max={IMAGE_BRUSH_SIZE_RANGE.max}
        step={5}
        {...{ onValueChange, onValueCommit }}
        value={[value]}
        defaultValue={[value]}
      />
    );
  }

  /*
   * HTML
   */

  return <div className="w-full h-10 p-2">{render_slider()}</div>;
}
